import { Reveal } from "./Reveal";
import { SHOTS } from "./assets";

const FRAMES = [
  { src: SHOTS.ledger, label: "Today's ledger" },
  { src: SHOTS.declare, label: "Declare it" },
  { src: SHOTS.gym, label: "Gym after work" },
  { src: SHOTS.record, label: "The record" },
  { src: SHOTS.run, label: "5K before work" },
  { src: SHOTS.cook, label: "Cooked, not ordered" },
  { src: SHOTS.read, label: "20 pages down" },
  { src: SHOTS.commitment, label: "New commitment" },
];

export const Showcase = () => {
  return (
    <section id="showcase" className="relative overflow-hidden border-y border-[#1F1F1F] bg-[#050505] py-24 md:py-36">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#C9A94B] opacity-[0.05] blur-[140px]" />

      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="mb-16 max-w-2xl">
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#C9A94B]">
              [ The app ]
            </span>
            <h2 className="mt-4 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
              Built for people<br />who show up.
            </h2>
            <p className="mt-5 font-body text-base leading-relaxed text-[#A1A1AA]">
              A disciplined interface with a single job: hold you to your word. Streaks, a 52-week
              proof heatmap, and a circle that actually keeps you honest.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {FRAMES.map((f, i) => (
            <Reveal key={f.label} delay={i * 0.07}>
              <figure className="group">
                <div className="relative overflow-hidden border border-[#1F1F1F] bg-[#0A0A0A] p-1.5 transition-colors duration-300 group-hover:border-[#C9A94B]/50">
                  <div className="aspect-[9/19.5] overflow-hidden">
                    <img
                      src={f.src}
                      alt={`proof — ${f.label}`}
                      loading="lazy"
                      className="h-full w-full object-cover grayscale-[0.15] transition-all duration-500 group-hover:grayscale-0 group-hover:scale-[1.03]"
                    />
                  </div>
                </div>
                <figcaption className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8A8A8A]">
                  <span className="text-[#C9A94B]">{String(i + 1).padStart(2, "0")}</span>
                  {f.label}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
